<!-- desktop view -->
<div class="container-fluid mb-3 hidden md:block" style="margin-top:55px;">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="bg-white pt-3 pb-3">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="section-header mb-2">Certificates</h5>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="container-fluid" style="background-color: #f8f8f8; padding-top:0">
                        <div class="row custom-card p-3 pb-2">
                            <div class="col-3">
                                <h6>Program</h6>
                            </div>
                            <div class="col-3">
                                <h6>Date uploaded</h6>
                            </div>
                            <div class="col-3">
                                <h6>Action</h6>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid" style="padding-top:0">
                        <div class="row">
                            <div class="col-12">
                                <div class="container-fluid">
                                    <div class="row custom-card mb-2" style="border-radius: 3px"
                                        *ngFor="let stud_cert of  student_certificates">
                                        <div class="col-3 p-3">{{ stud_cert?.program_type }}</div>
                                        <div class="col-3 p-3">{{ stud_cert?.created_at | date:'yyyy-MM-dd' }}</div>

                                        <div class="col-3 p-3">
                                            <div class="col-3 p-3">

                                                <button mat-raised-button (click)="downloadCertificate(stud_cert)"
                                                    title="download"><mat-icon>download</mat-icon></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- mobile view -->

<div class="container-fluid mb-3 md:hidden" style="margin-top:55px;">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="bg-white pt-3 pb-3">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="section-header">Certificates</h5>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="container-fluid" style="padding-top:0">
                        <div class="row">
                            <div class="col-12">
                                <div class="container-fluid">
                                    <div class="row custom-card mb-2 animated fadeIn"
                                        *ngFor="let stud_cert of  student_certificates" style="border-radius: 3px">
                                        <div class="col-5 p-3">
                                            <p class="section-header">{{stud_cert.program_type }}</p>

                                        </div>
                                        <div class="col-7 p-3">
                                            <div>{{ stud_cert?.created_at | date:'yyyy-MM-dd' }}</div>

                                            <button (click)="downloadCertificate(stud_cert)" mat-raised-button
                                                class="mr-2" title="view"><mat-icon>download</mat-icon></button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pl-3">
                    <p></p>
                </div>
            </div>

        </div>
    </div>
</div>